import React from 'react'
import { Box, TextField, Typography, MenuItem } from '@mui/material'
import { ROUNDING_OPTIONS, describeRule } from '../../utils/menuMarkup'

// Reusable markup% + rounding-mode + value controls. Used for the menu default,
// per-category overrides, and per-item markup overrides so the control behaves
// identically everywhere. Controlled via value/onChange props.
//
// Props:
//   pct, mode, value           current values (strings)
//   onChange({ pct, mode, value })   called with the full next state on any edit
//   showMarkup (default true)  hide the markup% field where it's implied
//   dense (default false)      compact layout for inline rows
export default function RoundingRuleFields({ pct, mode, value, onChange, showMarkup = true, dense = false }) {
  const isEnding = mode === 'UP_ENDING' || mode === 'DOWN_ENDING'
  const set = (patch) => onChange({ pct, mode, value, ...patch })
  return (
    <Box sx={{ display: 'flex', gap: dense ? 1 : 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
      {showMarkup && (
        <TextField
          type="number"
          size={dense ? 'small' : 'medium'}
          label="Markup %"
          value={pct}
          onChange={e => set({ pct: e.target.value })}
          placeholder="0"
          inputProps={{ min: 0, step: 0.5 }}
          InputProps={{ endAdornment: <Typography sx={{ color: '#94a3b8' }}>%</Typography> }}
          sx={{ width: dense ? 110 : 140 }}
        />
      )}
      <TextField
        select
        size={dense ? 'small' : 'medium'}
        label="Rounding"
        value={mode}
        onChange={e => set({ mode: e.target.value })}
        sx={{ minWidth: dense ? 170 : 210, flex: dense ? 'none' : 1 }}
      >
        {ROUNDING_OPTIONS.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </TextField>
      {mode !== 'AS_IS' && (
        <TextField
          type="number"
          size={dense ? 'small' : 'medium'}
          label={isEnding ? 'Ending (e.g. 0.99)' : 'Increment (e.g. 0.25)'}
          value={value}
          onChange={e => set({ value: e.target.value })}
          placeholder={isEnding ? '0.99' : '0.25'}
          inputProps={{ min: 0, step: 0.05 }}
          InputProps={{ startAdornment: <Typography sx={{ color: '#94a3b8', mr: 0.5 }}>$</Typography> }}
          sx={{ width: dense ? 150 : 190 }}
          helperText={!dense ? describeRule(mode, value) : undefined}
        />
      )}
    </Box>
  )
}
